// Shared bits between the promo card add and edit forms.
export const PLACEMENT_OPTIONS = [
  { value: 'fixture', text: 'Fixture' },
  { value: 'rank', text: 'Rank' },
  { value: 'members', text: 'Members' },
  { value: 'rivals', text: 'Rivals' },
]

const isValidDate = (date) => date instanceof Date && !Number.isNaN(date.getTime())

// Turns a stored API date into something CDatePicker can take. Blank dates used to be
// saved as the string "null" (FormData stringifies null), which the picker renders as
// NaN/NaN/NaN and keeps re-emitting, so anything that isn't a real date becomes ''.
export const toPickerDate = (value) => {
  if (!value || typeof value !== 'string' || value.startsWith('0000-00-00')) return ''
  return isValidDate(new Date(value)) ? value : ''
}

// What the date pickers show.
export const formatDisplayDate = (date) => {
  if (!isValidDate(date)) return ''
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${day}/${month}/${date.getFullYear()}`
}

// What the API stores.
export const toApiDate = (date) => {
  if (!isValidDate(date)) return ''
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}
